"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const admin_1 = require("../../shared-types/admin");
exports.requestSchema = zod_1.z.object({
    propertyIds: zod_1.z.array(zod_1.z.number()).min(1),
    permissionsToDelete: zod_1.z.array(admin_1.PermissionDefinitionIDSchema),
    permissionsToCreate: zod_1.z.array(admin_1.PermissionDefinitionIDSchema),
});
exports.path = '/admin-update-property-permissions';
//# sourceMappingURL=index.js.map